var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.683,
    height: 35.683,
    viewBox: "0 0 35.683 35.683",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ff3147;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M17.841,0A17.841,17.841,0,1,0,35.683,17.841,17.861,17.861,0,0,0,17.841,0Zm8.485,27.07a1.485,1.485,0,0,1-2.1,0L16.79,19.636a1.48,1.48,0,0,1-.436-1.051V8.921a1.487,1.487,0,1,1,2.973,0v9.049l7,7a1.485,1.485,0,0,1,0,2.1Zm0,0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock3);
export default __webpack_public_path__ + "static/media/clock (3).6a40be01235feba7385ae404a1147e0e.svg";
export { ForwardRef as ReactComponent };